import { useState } from "react";
import { useNavigate } from "hooks/useCustomNavigation";
import chevronOn from "assets/search-dropdown-chevron-on.svg";
import chevronOff from "assets/search-dropdown-chevron-off.svg";
import { useGetBrandInfo } from "./utils/useGetBrandInfo";
import "./index.scss";

export const BRAND_PLACEHOLDER =
  "https://s3.amazonaws.com/assets.coupontrade.com/pay/static/media/brandPlaceholder.png";

export const SearchDropdownItem = ({
  value,
  src,
  info,
  path,
  cashBack,
  available
}) => {
  const navigate = useNavigate();
  const { generateBrandInfoString } = useGetBrandInfo({
    info,
    cashBack,
    available
  });
  const [isSelected, setIsSelected] = useState(false);
  const navigateToBrandPage = () => {
    navigate(path);
  };

  return (
    <div
      data-testid="search-dropdown-item"
      className={`search-dropdown-item ${isSelected ? "is-selected" : ""}`}
      onMouseEnter={() => setIsSelected(true)}
      onMouseLeave={() => setIsSelected(false)}
      onClick={navigateToBrandPage}
    >
      <img className="brandImage" src={src || BRAND_PLACEHOLDER} alt={value} />
      <span className="brandLabel">
        <span className="brandTitle">{value}</span>
        <span className="brandInfo">{generateBrandInfoString()}</span>
      </span>
      <img
        className="chevron"
        src={isSelected ? chevronOn : chevronOff}
        alt={`chevron-${isSelected ? "on" : "off"}`}
      />
    </div>
  );
};
